/*
----------------------------
Module - list-box
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    fmg.listBox = function() {

        function updateListBox($listbox) {

            var $dropdown_btn = $listbox.find(".list-box__button");

            var plural_noun = $listbox.data("plural-noun");

            var $checked_checkboxes = $listbox.find("input[type=checkbox]:checked");

            var num_checked = $checked_checkboxes.length;

            if ($listbox.hasClass("list-box__select-all")) {
                        
                // Toggle all checkboxes but 'All' based on the checked state of the All input
                // $list_box_inputs.not(this).prop('checked', this.checked);

                // $dropdown_btn.text("All");

                // console.log(num_checked);

                // if(num_checked == 1){
                //     $dropdown_btn.addClass("list-box__button--populated");
                // }

                // else if(num_checked > 1){ 
                //     $dropdown_btn.removeClass("list-box__button--populated");
                // }

            }

            else {

                if (num_checked === 0) {
                    $dropdown_btn.text("All");
                    $dropdown_btn.removeClass("list-box__button--populated");
                } else if (num_checked === 1) {
                    $dropdown_btn.text($checked_checkboxes[0].value);
                    $dropdown_btn.addClass("list-box__button--populated");
                } else {
                    $dropdown_btn.text(num_checked + " " + plural_noun + " selected");
                    $dropdown_btn.addClass("list-box__button--populated");
                }

            }

        }

        function setupListBoxes(){

            $list_boxes.each(function() {
            
                var $this_list_box = $(this);

                // Run this function on page load so that number selected is correct if some checkboxes are prefilled
                updateListBox($this_list_box);

                // Bind change event on checkboxes so that number selected is correct after change event
                var $this_list_box_inputs = $this_list_box.find("input[type=checkbox]");
                                
                $this_list_box_inputs.on("change", function() {
                    updateListBox($this_list_box);
                });

            });

        }
        

        function toggleSubmenu($button, is_active) {

            var $parent_menu = $button.parent();
            var $sub_menu = $button.parent().find(".list-box__submenu");
            
            if (is_active === "false") {

                $parent_menu.addClass(menu_expanded_classname);

                // Expand submenu
                $sub_menu.slideDown("fast");

                $button.attr("aria-expanded", "true");

            } else {
                
                // Close submenu
                // Remove class only after the sub menu is closed completely
                $sub_menu.slideUp("fast", function() {
                    $parent_menu.removeClass(menu_expanded_classname);
                });

                $button.attr("aria-expanded", "false");

            }

        }

        function closeExpandedSubmenus() {

            var $active_buttons = $buttons.filter("[aria-expanded='true']");
                        
            if ($active_buttons.length) {

                toggleSubmenu($active_buttons, "true");

            }

        }

        function closeListBoxOnOutsideClick() {

            $(document).on("click", function(evt){

                var $target = $(evt.target);
                var parent = ".list-box";

                if(!fmg.fn.isElementWithinParent($target, parent)) {
                    closeExpandedSubmenus();
                }

            });

        }

        function init(){

            $buttons = $list_boxes.find(".list-box__button");
            
            setupListBoxes();
            closeListBoxOnOutsideClick();

        }

        var $list_boxes = $(".list-box");
        var $buttons;
        var menu_expanded_classname = "list-box__menu-item--expanded";
        
        return {
            init: init
        };

    }()


    document.addEventListener("DOMContentLoaded", function () {
        fmg.listBox.init();
    });

}());